// One localStorage-backed preference with a cross-tree CustomEvent bridge.
// Replaces the accent/density/expFeatures/themeMode controllers and the
// hand-rolled prefs in Configuracion.jsx.
export function createPreference(
  key,
  { fallback, valid, applyAttr, encode, decode } = {},
) {
  const EVENT = `rec:pref:${key}`;
  const read = () => {
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return fallback;
      const v = decode ? decode(raw) : raw;
      return valid && !valid.includes(v) ? fallback : v;
    } catch {
      return fallback;
    }
  };
  const apply = (v) => {
    if (applyAttr) document.documentElement.dataset[applyAttr] = v;
  };
  return {
    key,
    EVENT,
    resolve: read,
    init: () => apply(read()),
    set: (v) => {
      const next = valid && !valid.includes(v) ? fallback : v;
      try {
        localStorage.setItem(key, encode ? encode(next) : next);
      } catch {
        // localStorage throws in some private-mode/embedded contexts; if it is
        // unavailable the choice just does not persist.
      }
      apply(next);
      window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
      return next;
    },
  };
}
